var _g, _path, _ellipse, _path2, _path3, _path4, _rect, _path5, _ellipse2, _ellipse3, _ellipse4, _path6, _path7, _path8, _path9, _rect2, _rect3, _rect4, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllust2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 267.576,
    height: 202.127,
    viewBox: "0 0 267.576 202.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_802",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 802",
    transform: "translate(-817.476 -2810.418)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_709",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 709",
    transform: "translate(817.476 2810.418)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_40",
    "data-name": "\\u6955\\u5186\\u5F62 40",
    cx: 11.621,
    cy: 11.621,
    rx: 11.621,
    ry: 11.621,
    transform: "translate(101.565 56.699)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_184",
    "data-name": "\\u30D1\\u30B9 184",
    d: "M442.278,174.89a11.623,11.623,0,0,1,10.23,17.136,11.618,11.618,0,1,0-19.3-12.766A11.592,11.592,0,0,1,442.278,174.89Z",
    transform: "translate(-325.855 -117.871)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_41",
    "data-name": "\\u6955\\u5186\\u5F62 41",
    cx: 34.136,
    cy: 34.136,
    rx: 34.136,
    ry: 34.136,
    transform: "translate(57.336 0.024)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_185",
    "data-name": "\\u30D1\\u30B9 185",
    d: "M277.52,12.988a34.129,34.129,0,0,1,47.308-3.579c-.279-.265-.555-.533-.845-.791a34.136,34.136,0,0,0-45.36,51.024c.29.258.588.5.884.747A34.129,34.129,0,0,1,277.52,12.988Z",
    transform: "translate(-212.84 -0.007)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_42",
    "data-name": "\\u6955\\u5186\\u5F62 42",
    cx: 21.986,
    cy: 21.986,
    rx: 21.986,
    ry: 21.986,
    transform: "translate(69.196 24.035)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_186",
    "data-name": "\\u30D1\\u30B9 186",
    d: "M276.427,231.7,252.9,232.753s1.964,12.167-10.765,13.324-24.3-2.314-28.928,6.364-2.634,39.58-2.634,39.58,8.679,31.243,15.621,35.871,67.693-1.736,67.693-1.736l25.424-32.1L318.45,269.3a21.227,21.227,0,0,0-24.966-20.242q-.375.07-.754.152c-.38.081-2.793-2.087-10.456-5.919C277.588,240.946,276.427,231.7,276.427,231.7Z",
    transform: "translate(-174.014 -157.721)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_187",
    "data-name": "\\u30D1\\u30B9 187",
    d: "M257.786,271.639s5.592,10.146,3.278,24.61,7.4,45.056,7.4,45.056l6.943-1.736s-4.629-30.086-3.472-37.028,1.476-27.43-4.309-30.9S257.786,271.639,257.786,271.639Z",
    transform: "translate(-206.444 -183.861)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_188",
    "data-name": "\\u30D1\\u30B9 188",
    d: "M467.516,284.455l2.432,64.057,4.629,2.893s6.654-70.3,3.182-70.3H470.7a3.183,3.183,0,0,0-3.183,3.184h0C467.512,284.347,467.513,284.4,467.516,284.455Z",
    transform: "translate(-349.208 -191.357)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_43",
    "data-name": "\\u6955\\u5186\\u5F62 43",
    cx: 2.893,
    cy: 2.893,
    rx: 2.893,
    ry: 2.893,
    transform: "translate(62.305 150.212)",
    fill: "#224ea8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_44",
    "data-name": "\\u6955\\u5186\\u5F62 44",
    cx: 2.893,
    cy: 2.893,
    rx: 2.893,
    ry: 2.893,
    transform: "translate(120.162 153.105)",
    fill: "#224ea8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_189",
    "data-name": "\\u30D1\\u30B9 189",
    d: "M323.672,58.069V80.055h5.092l6.48-6.943-.868,6.943h22.506l-1.389-6.943,2.777,6.943h3.587V58.069Z",
    transform: "translate(-251.294 -39.531)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_45",
    "data-name": "\\u6955\\u5186\\u5F62 45",
    cx: 1.736,
    cy: 3.182,
    rx: 1.736,
    ry: 3.182,
    transform: "translate(67.171 38.21)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_46",
    "data-name": "\\u6955\\u5186\\u5F62 46",
    cx: 1.736,
    cy: 3.182,
    rx: 1.736,
    ry: 3.182,
    transform: "translate(111.721 38.21)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_190",
    "data-name": "\\u30D1\\u30B9 190",
    d: "M280.895,597v1.938a4.259,4.259,0,0,1-.29,1.555,4.373,4.373,0,0,1-.31.639,4.29,4.29,0,0,1-3.688,2.095H134.03a4.29,4.29,0,0,1-3.688-2.095,4.341,4.341,0,0,1-.31-.639,4.253,4.253,0,0,1-.291-1.555V597a4.287,4.287,0,0,1,4.286-4.288h8.221v-.9a.178.178,0,0,1,.178-.179h4.289a.179.179,0,0,1,.179.178v.9h2.679v-.9a.178.178,0,0,1,.178-.179h4.289a.179.179,0,0,1,.179.178v.9H156.9v-.9a.178.178,0,0,1,.178-.179h4.289a.179.179,0,0,1,.179.178v.9h2.679v-.9a.178.178,0,0,1,.178-.179h4.289a.179.179,0,0,1,.179.178v.9h2.679v-.9a.178.178,0,0,1,.178-.179h4.289a.179.179,0,0,1,.179.178v.9h2.682v-.9a.178.178,0,0,1,.178-.179h4.289a.179.179,0,0,1,.179.178v.9H186.2v-.9a.178.178,0,0,1,.178-.179h33.589a.179.179,0,0,1,.179.178h0v.9h2.682v-.9a.178.178,0,0,1,.178-.179H227.3a.181.181,0,0,1,.179.179v.9h2.679v-.9a.178.178,0,0,1,.178-.179h4.289a.179.179,0,0,1,.179.178h0v.9h2.679v-.9a.178.178,0,0,1,.178-.179h4.289a.179.179,0,0,1,.179.178h0v.9h2.682v-.9a.178.178,0,0,1,.178-.179h4.289a.178.178,0,0,1,.176.179v.9h2.682v-.9a.178.178,0,0,1,.178-.179H256.6a.179.179,0,0,1,.179.178h0v.9h2.679v-.9a.178.178,0,0,1,.178-.179h4.289a.179.179,0,0,1,.179.178h0v.9h12.506a4.287,4.287,0,0,1,4.288,4.286Z",
    transform: "translate(-119.283 -402.731)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_475",
    "data-name": "\\u9577\\u65B9\\u5F62 475",
    width: 267.576,
    height: 0.639,
    transform: "translate(0 199.992)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_191",
    "data-name": "\\u30D1\\u30B9 191",
    d: "M281.088,352.812h-130.6a3.6,3.6,0,0,0-3.595,3.595h0v72.768a3.6,3.6,0,0,0,3.595,3.595h130.6a3.6,3.6,0,0,0,3.595-3.595V356.407a3.6,3.6,0,0,0-3.595-3.595Z",
    transform: "translate(-130.957 -240.167)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_47",
    "data-name": "\\u6955\\u5186\\u5F62 47",
    cx: 7.982,
    cy: 7.982,
    rx: 7.982,
    ry: 7.982,
    transform: "translate(76.953 130.068)",
    fill: "#224ea8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_710",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 710",
    transform: "translate(996.54 2976.073)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_192",
    "data-name": "\\u30D1\\u30B9 192",
    d: "M183.215,623.081c0,1.533-14.2,6.138-31.712,6.138s-31.712-4.6-31.712-6.138,14.2.584,31.712.584S183.215,621.547,183.215,623.081Z",
    transform: "translate(-115.521 -592.746)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_193",
    "data-name": "\\u30D1\\u30B9 193",
    d: "M183.215,623.081c0,1.533-14.2,6.138-31.712,6.138s-31.712-4.6-31.712-6.138,14.2.584,31.712.584S183.215,621.547,183.215,623.081Z",
    transform: "translate(-115.521 -592.746)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_48",
    "data-name": "\\u6955\\u5186\\u5F62 48",
    cx: 31.712,
    cy: 2.777,
    rx: 31.712,
    ry: 2.777,
    transform: "translate(4.27 27.558)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_49",
    "data-name": "\\u6955\\u5186\\u5F62 49",
    cx: 13.051,
    cy: 1.22,
    rx: 13.051,
    ry: 1.22,
    transform: "translate(22.687 29.393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_194",
    "data-name": "\\u30D1\\u30B9 194",
    d: "M238.137,399.63H223.882v.09H189.791v4.94a22.991,22.991,0,0,0,22.991,22.991h0a22.98,22.98,0,0,0,19.861-11.4h5.495a8.309,8.309,0,0,0,0-16.617Zm0,14.056h-4.2a22.917,22.917,0,0,0,1.84-9.026v-2.469h2.364a5.747,5.747,0,0,1,.005,11.495Z",
    transform: "translate(-176.983 -397.039)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_195",
    "data-name": "\\u30D1\\u30B9 195",
    d: "M207.291,417.871v2.805a20.857,20.857,0,1,0,41.714,0v-2.805Z",
    transform: "translate(-192.349 -413.055)",
    fill: "#224ea8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_196",
    "data-name": "\\u30D1\\u30B9 196",
    d: "M293.9,459.862l-4.775-4.921a2.609,2.609,0,0,1,.056-3.689h0l7.222-7.007a1.836,1.836,0,0,1,.6-.388l1.569-.627a1.838,1.838,0,0,1,2,.427l4.986,5.139a1.838,1.838,0,0,1,.391,1.953l-.528,1.342a1.839,1.839,0,0,1-.431.647l-7.4,7.181A2.609,2.609,0,0,1,293.9,459.862Z",
    transform: "translate(-263.558 -435.206)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_476",
    "data-name": "\\u9577\\u65B9\\u5F62 476",
    width: 0.5,
    height: 3.331,
    transform: "matrix(0.718, -0.696, 0.696, 0.718, 37.348, 10.706)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_197",
    "data-name": "\\u30D1\\u30B9 197",
    d: "M401.239,396.6c.422-1,1.68-1.218,2.616-1.416a3.187,3.187,0,0,0,2.541-1.613,1.371,1.371,0,0,0-.134-1.308,1.266,1.266,0,0,0-1.1-.593c-.926.083-1.092,1.177-.738,1.868.478.932,1.7,1.013,2.623,1.036a5.658,5.658,0,0,0,2.649-.413,2.176,2.176,0,0,0,1.221-2.054,11.2,11.2,0,0,0-.659-2.58,2.486,2.486,0,0,1,.305-2.4,3.879,3.879,0,0,1,2.346-1.052c.216-.034.433-.057.65-.075.233-.019.235-.385,0-.366-1.558.125-3.6.662-3.823,2.5a5.81,5.81,0,0,0,.472,2.455,3.441,3.441,0,0,1,.212,2.322,2.3,2.3,0,0,1-1.933,1.232,7.7,7.7,0,0,1-1.277.069,5.87,5.87,0,0,1-1.471-.148,1.509,1.509,0,0,1-1.007-.727,1.1,1.1,0,0,1-.029-.978.633.633,0,0,1,.862-.242l.032.019a1.047,1.047,0,0,1,.532,1.009c-.134,1.036-1.319,1.453-2.186,1.646a4.719,4.719,0,0,0-2.716,1.151,2.049,2.049,0,0,0-.346.562.184.184,0,0,0,.128.225.187.187,0,0,0,.225-.128Z",
    transform: "translate(-362.325 -384.751)",
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_50",
    "data-name": "\\u6955\\u5186\\u5F62 50",
    cx: 1.342,
    cy: 1.342,
    rx: 1.342,
    ry: 1.342,
    transform: "translate(22.809 7.682)",
    fill: "#e6e6e6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_51",
    "data-name": "\\u6955\\u5186\\u5F62 51",
    cx: 1.342,
    cy: 1.342,
    rx: 1.342,
    ry: 1.342,
    transform: "translate(47.447 12.683)",
    fill: "#e6e6e6"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_52",
    "data-name": "\\u6955\\u5186\\u5F62 52",
    cx: 0.976,
    cy: 0.976,
    rx: 0.976,
    ry: 0.976,
    transform: "translate(41.105 20.123)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_198",
    "data-name": "\\u30D1\\u30B9 198",
    d: "M101.076,600.423a26.434,26.434,0,0,0,8.382.232,12.89,12.89,0,0,0-6.047-2.987,26.433,26.433,0,0,0-8.382-.232A12.893,12.893,0,0,0,101.076,600.423Z",
    transform: "translate(-93.779 -570.514)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_199",
    "data-name": "\\u30D1\\u30B9 199",
    d: "M92.472,614.248a23.3,23.3,0,0,0,8.019-1.273,21.115,21.115,0,0,0-7.69-1.726,23.3,23.3,0,0,0-8.019,1.273A21.114,21.114,0,0,0,92.472,614.248Z",
    transform: "translate(-84.782 -582.84)",
    fill: "#224ea8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_200",
    "data-name": "\\u30D1\\u30B9 200",
    d: "M124.734,583.271a22.451,22.451,0,0,0,7.663,1.758s-.461-2.338-3.56-3.9a22.448,22.448,0,0,0-7.663-1.758S121.635,581.709,124.734,583.271Z",
    transform: "translate(-116.735 -554.857)",
    fill: "#224ea8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_201",
    "data-name": "\\u30D1\\u30B9 201",
    d: "M206.791,418.371v2.805a20.857,20.857,0,0,0,41.714,0v-2.805Z",
    transform: "translate(-191.91 -413.494)",
    fill: "#224ea8",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_202",
    "data-name": "\\u30D1\\u30B9 202",
    d: "M496.564,383.067l-2.1,1.06a.866.866,0,0,1-1.175-.34l-1.446-2.867a.552.552,0,0,1-.058-.221l-.028-.544a.633.633,0,0,1,.357-.587l2.194-1.107a.635.635,0,0,1,.668.049l.371.282a.552.552,0,0,1,.159.191l1.482,2.938A.866.866,0,0,1,496.564,383.067Z",
    transform: "translate(-442.117 -378.389)",
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_477",
    "data-name": "\\u9577\\u65B9\\u5F62 477",
    width: 2.531,
    height: 0.732,
    transform: "translate(50.508 2.263) rotate(-26.507)",
    fill: "#224ea8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_478",
    "data-name": "\\u9577\\u65B9\\u5F62 478",
    width: 2.531,
    height: 0.732,
    transform: "translate(50.996 3.117) rotate(-26.507)",
    fill: "#224ea8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_479",
    "data-name": "\\u9577\\u65B9\\u5F62 479",
    width: 2.531,
    height: 0.732,
    transform: "translate(51.484 4.093) rotate(-26.507)",
    fill: "#224ea8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_711",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 711",
    transform: "translate(298.17 2492.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_203",
    "data-name": "\\u30D1\\u30B9 203",
    d: "M731.408,468.052h0a128.829,128.829,0,0,1-1.537-33.269l1.537-18.377h0c-8.473,14.12-6.558,32.7,0,51.646Z",
    transform: "translate(1 5.023)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_204",
    "data-name": "\\u30D1\\u30B9 204",
    d: "M738.748,485.684h0a61.072,61.072,0,0,0,1.119-19.5l-1.119-10.773h0C744.915,463.684,743.521,474.579,738.748,485.684Z",
    transform: "translate(-2.733 -4.938)",
    fill: "#cacaca"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllust2);
export default __webpack_public_path__ + "static/media/illust_2.7336cbb3ae0a711fb71e0a025427f211.svg";
export { ForwardRef as ReactComponent };